export type TRole =
  | "Owner"
  | "Super Admin"
  | "Policy Admin"
  | "Security Admin"
  | "Staff";

class PermissionPolicyChecker {
  private static instance: PermissionPolicyChecker;

  static getInstance(role: TRole) {
    if (!PermissionPolicyChecker.instance) {
      PermissionPolicyChecker.instance = new PermissionPolicyChecker(role);
    }
    return PermissionPolicyChecker.instance;
  }

  private readonly _role: TRole;

  constructor(role: TRole) {
    this._role = role;
  }

  private eligible = (roles: TRole[]) => {
    return roles.includes(this._role);
  };

  private ineligible = (roles: TRole[]) => {
    return !roles.includes(this._role);
  };

  //INFO: 설정 탭 권한
  get canUse캘린더연동() {
    return this.eligible(["Owner"]);
  }

  get canUse비공개회의데이터설정() {
    return this.eligible(["Owner", "Super Admin"]);
  }

  get canAccess기업정보관리() {
    return this.eligible(["Owner", "Super Admin"]);
  }

  get canAccess멤버권한관리() {
    return this.eligible(["Owner", "Super Admin"]);
  }

  get canAccess서비스연동관리() {
    return this.eligible(["Owner", "Super Admin"]);
  }

  get canAccess내정보관리() {
    return this.eligible([
      "Owner",
      "Super Admin",
      "Policy Admin",
      "Staff",
      "Security Admin",
    ]);
  }

  //INFO: Mile Meeting 탭 권한
  get canAccessMeeting정책관리() {
    return this.eligible(["Owner", "Super Admin", "Policy Admin"]);
  }

  get canAccessMeeting회의실민원관리() {
    return this.eligible(["Owner", "Super Admin", "Policy Admin"]);
  }

  //INFO: Mile Analytics 탭 권한
  get canAccess애널리틱스() {
    return this.eligible(["Owner", "Super Admin", "Security Admin"]);
  }

  //INFO: Mile Visitors 탭 권한
  get canAccessVisitors서비스커스터마이징() {
    return this.eligible(["Owner", "Super Admin", "Policy Admin"]);
  }

  get canAccessVisitors기기관리() {
    return this.eligible(["Owner", "Super Admin", "Policy Admin"]);
  }
}

export default PermissionPolicyChecker;
